// src/config/tokens.js

export const SUPPORTED_TOKENS = {
  ETH: {
    symbol: 'ETH',
    name: 'Ethereum',
    decimals: 18,
    isNative: true,
    icon: '⟠',
    color: '#627EEA',
    coingeckoId: 'ethereum'
  },
  BNB: {
    symbol: 'BNB',
    name: 'Binance Coin',
    decimals: 18,
    isNative: true,
    icon: '🟡',
    color: '#F3BA2F',
     coingeckoId: 'binancecoin'
  },
  USDT: {
    symbol: 'USDT',
    name: 'Tether USD',
    decimals: 18, 
    icon: '₮',
    color: '#26A17B',
    coingeckoId: 'tether',
    addresses: {
      56: '0x55d398326f99059fF775485246999027B3197955', // BSC Mainnet
      97: '0x7ef95a0FEE0Dd31b22626fF2be2D82c9b7b5B32B'  // BSC Testnet
    }
  },
  USDC: {
    symbol: 'USDC',
    name: 'USD Coin',
    decimals: 18, 
    icon: '💵',
    color: '#2775CA',
    coingeckoId: 'usd-coin',
    addresses: {
      56: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d', // BSC Mainnet
      97: '0x64544969ed7EBf5f083679233325356EbE738930',  // BSC Testnet
      11155111: '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238', // Sepolia
    }
  },
  BUSD: {
    symbol: 'BUSD',
    name: 'Binance USD',
    decimals: 18,
    icon: '💰',
    color: '#F0B90B',
    coingeckoId: 'binance-usd',
    addresses: {
      56: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56', // BSC Mainnet
      97: '0x78867BbEeF44f2326bF8DDd1941a4439382EF2A7'  // BSC Testnet
    }
  },
  BIOFI: {
    symbol: 'BIOFI',
    name: 'BioFi Token',
    decimals: 18,
    icon: '🧬',
    color: '#A020F0',
    coingeckoId: 'biometric-financial',
    addresses: {
      56: '0x11a31b833d43853f8869c9eec17f60e3b4d2a753' // BSC Mainnet
    }
  }
};

export const CHAIN_CONFIG = {
  56: { name: 'BSC Mainnet', color: '#F3BA2F', icon: '🟡', enabled: true },
  97: { name: 'BSC Testnet', color: '#F3BA2F', icon: '🧪', enabled: true },
  11155111: { name: 'Sepolia', color: '#FF6B6B', icon: '🧪', enabled: true },
  1: { name: 'Ethereum', color: '#627EEA', icon: '⟠', enabled: false },
  137: { name: 'Polygon', color: '#8247E5', icon: '⬡', enabled: false },
  8453: { name: 'Base', color: '#0052FF', icon: '🔵', enabled: false },
  42161: { name: 'Arbitrum', color: '#28A0F0', icon: '🔷', enabled: false },
  43114: { name: 'Avalanche', color: '#E84142', icon: '🔺', enabled: false }
};

// Get token address for specific chain
export const getTokenAddress = (tokenSymbol, chainId) => {
  const token = SUPPORTED_TOKENS[tokenSymbol];
  if (!token || token.isNative) return null;
  return token.addresses[chainId] || null;
};

// Check if token is supported on chain
export const isTokenSupportedOnChain = (tokenSymbol, chainId) => {
  const token = SUPPORTED_TOKENS[tokenSymbol];
  if (!token) return false;
  
  if (token.isNative) {
    if (tokenSymbol === 'BNB') {
      return [56, 97].includes(chainId);
    }
    if (tokenSymbol === 'ETH') {
      return false;
    }
    return false;
  }
  
  // For ERC20 tokens, check if address exists for this chain
  return !!token.addresses?.[chainId];
};